/* eslint-disable no-empty-function */
export default () => {};
/* eslint-enable no-empty-function */
